module.exports = __webpack_public_path__ + "img/7d16e2e54fdd9249761048bd31f86179.png";